import useViewportSpy from 'beautiful-react-hooks/useViewportSpy';
import clsx from 'clsx';
import { useMemo, useRef } from 'react';

import DynamicCardComponent from './DynamicCardComponent';
import { useInfiniteScroll } from './hooks/useInfiniteScroll';
import { useItemsToShow } from './hooks/useItemsToShow';
import { useRelevancyFeed } from './model';
import { useRelevancyOptions } from './store';
import { getAdditionalClasses } from './utils';

import GamingHub from '@shared/GamingHub';

export const RelevancyMosaic = () => {
  const { isLoading } = useRelevancyFeed();
  const { options } = useRelevancyOptions();
  const scrollSpyRef = useRef(null);
  const scrolled = useViewportSpy(scrollSpyRef);
  const cardIndex = useRef(0);

  useInfiniteScroll(scrolled);

  const { itemsToShow } = useItemsToShow();

  const additionalClasses = useMemo(
    () => getAdditionalClasses(itemsToShow.length, options.design, options.isPortrait),
    [itemsToShow.length, options.design, options.isPortrait],
  );

  return (
    <>
      {!options.useEidos && <GamingHub options={options} passiveMode />}
      <div
        className={clsx('mosaic relevance-mosaic-wrap js-tracking-container', options.design, additionalClasses)}
        data-tracking-container='mosaic'
      >
        {itemsToShow.map((item, i) => {
          if (i === 0) cardIndex.current = -1;
          if (!item.hidden) cardIndex.current++;
          return (
            <DynamicCardComponent
              key={`item_${item.cardId ?? i}`}
              item={item}
              index={cardIndex.current}
              items={itemsToShow}
            />
          );
        })}
      </div>
      <div ref={scrollSpyRef} />
      {isLoading && (
        <div className='loading'>
          <div className='spinner'>
            <div className='bounce' />
            <div className='bounce' />
            <div className='bounce' />
          </div>
        </div>
      )}
    </>
  );
};

export default RelevancyMosaic;
